var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GradientInput',{attrs:{"value":_vm.inputValue,"type":_vm.type,"label":_vm.label,"onFocus":() => (_vm.inProgress = true),"onBlur":_vm.onBlur,"inProgress":_vm.inProgress,"classes":"rgb"},on:{"input":_vm.onChangeHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }